/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const UpdateBillingPage = lazyLoad(
  () => import('./index'),
  module => module.UpdateBillingPage
);
